import styled from 'styled-components'
import PageHeader from '../PageHeader/PageHeader'
import PageNav from '../PageNav/PageNav'
import Breakpoints from '../../theme/breakpoints'
import { MOBILE_HEADER_HEIGHT } from '../../molecules/MobileHeader/MobileHeader.styles'

const Home = styled.div`
  min-height: 100%;

  [data-gtm] * {
    pointer-events: none;
  }
`

export const Nav = styled(PageNav)`
  grid-area: nav;
`

export const Header = styled(PageHeader)`
  grid-area: header;
`

export const Main = styled.main<{ hidden?: boolean }>`
  grid-area: main;
  padding-bottom: 100px;
  ${({ hidden = false }) => hidden && `
    visibility: hidden;
  `}

  @media (max-width: ${Breakpoints.tablet}) {
    width: 100vw;
    overflow-y: scroll;
    height: calc(100vh - ${MOBILE_HEADER_HEIGHT});
  }
`

export const Body = styled.div`
  min-height: 100%;
  display: grid;
  grid-template-rows: 64px 1fr;
  grid-template-columns: max-content;
  grid-template-areas:
    'nav header'
    'nav main';

  @media (max-width: ${Breakpoints.tablet}) {
    grid-template-columns: initial;
    grid-template-rows: max-content max-content;
    grid-template-areas:
      'header'
      'nav'
      'main';
  }
`

export default Home
